import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/Auth";
import { connect } from "react-redux";
import { updateFieldsLoad } from "../../appRedux/ducks/updateFields";
import { IconButton, Modal } from "@material-ui/core";
import moment from "moment";
import "./modal.css";
import CloseIcon from "@mui/icons-material/Close";
const InvestorSurvey = ({ setUserFields }) => {
  const [visible, setVisible] = useState(false);
  // Remembered for the rest of the session so a refetch of /user that races
  // the persisted flag written in closeModal cannot reopen the modal.
  const [dismissed, setDismissed] = useState(false);
  const { userData, user } = useAuth();
  useEffect(() => {
    const createdDate = moment(user?.metadata?.creationTime).format(
      "YYYY-MM-DD",
    );
    const daysDifference = moment().diff(createdDate, "days");
    // if its been 7 days since account creation and the user signed the docusign agreement already and they have not taken or dismissed this survey
    if (
      !!user &&
      user?.metadata.creationTime &&
      daysDifference >= 7 &&
      userData?.agreement_signed_new &&
      !userData?.investor_survey &&
      !userData?.investor_survey_dismissed &&
      !dismissed
    ) {
      // then show the modal
      setVisible(true);
    }
    // if they already took or dismissed the survey close it
    if (userData?.investor_survey || userData?.investor_survey_dismissed) {
      setVisible(false);
    }
  }, [userData, user, dismissed]);
  function closeModal() {
    setDismissed(true);
    setVisible(false);
    // Persist the dismissal on the member's document so the survey does not
    // come back on the next page load.
    setUserFields({ investor_survey_dismissed: true });
  }
  if (!userData) return null;
  return (
    <Modal open={visible} width={800} onClose={closeModal} footer={null}>
      <div
        className="outer-modal-container"
        style={{
          textAlign: "center",
          width: "55%",
          paddingBottom: "7px",
          position: "absolute",
          top: "2%",
          left: "24%",
          background: "white",
        }}
      >
        <IconButton
          onClick={closeModal}
          style={{ position: "absolute", top: "20px", right: "19px" }}
        >
          <CloseIcon className="ta-logo-modal-black" />
        </IconButton>
        <div style={{ height: "100%", overflow: "hidden" }}>
          {/* The completion webhook marks users/<uid>, so Zoho must be given
              the Firebase auth uid, not the document's legacy userId field. */}
          <iframe
            src={`https://survey.zohopublic.com/zs/cdD7R8?uid=${user?.uid || ""}&email=${userData?.email || ""}`}
            height="850px"
            width="95%"
            frameBorder="0"
            marginWidth="0"
            marginHeight="0"
            scrolling="auto"
            allow="geolocation"
            display="block"
          ></iframe>
        </div>
      </div>
    </Modal>
  );
};

const dispatchToProps = (dispatch) => ({
  setUserFields: (fields) => dispatch(updateFieldsLoad(fields)),
});
export default connect(null, dispatchToProps)(InvestorSurvey);
